import {onFind} from "@elements/init-modules-in-scope";
import {find, addClass, removeClass, on, findIn, findAll} from "@elements/dom-utils";

export function init () {
    onFind('.js-collapse-filter', function (collapse) {
        on('shown.bs.collapse', function () {
            findIn('.js-collapse-filter__state', collapse).value = 'true';
        }, collapse);

        on('hidden.bs.collapse', function () {
            findIn('.js-collapse-filter__state', collapse).value = 'false';
        }, collapse);
    });
}